import Pill from "components/Pill/PillElement";
import React from "react";

export interface DocumentLifeCyclePillProps {
  value: server.dto.DocumentLifeCycles
  overDue?: boolean
};

const DocumentLifeCyclePill = (props: DocumentLifeCyclePillProps) => {
  const { value, overDue } = props;

  switch (value) {
    case "draft":
      return <Pill color="darkgray" label={RESX.DocumentLifeCycle.Draft} />;
    case "review":
      return <Pill color="purple" label={RESX.DocumentLifeCycle.Review} />;
    case "pending":
      return overDue
        ? <Pill color="pink" label={RESX.DocumentLifeCycle.OutForSignature} />
        : <Pill color="orange" label={RESX.DocumentLifeCycle.OutForSignature} />;
    case "completed":
      return <Pill color="green" label={RESX.DocumentLifeCycle.Completed} />;
    case "discarded":
      return <Pill color="gray" label={RESX.DocumentLifeCycle.Discarded} />;
    default:
      console.error(`value ${value} is not implemented in DocumentLifeCycleLabel`);
  }
};

export default DocumentLifeCyclePill;